import { Box, BoxProps, styled } from "@mui/material";

const SocialBox = styled(Box)<BoxProps>(({ theme }) => ({
  position: "static",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 4,
  zIndex: 1,
  marginTop: theme.spacing(1.25),
  padding: theme.spacing(0.5),
  border: "1px solid rgba(255,255,255,0.24)",
  borderRadius: 999,
  backgroundColor: "rgba(10,34,156,0.32)",
  backdropFilter: "blur(10px)",
  "& a": {
    width: 44,
    height: 44,
    display: "grid",
    placeItems: "center",
    borderRadius: "50%",
    transition: "transform 160ms ease, background-color 160ms ease",
  },
  "& a:hover": {
    backgroundColor: "rgba(255,255,255,0.13)",
    transform: "translateY(-2px)",
  },
  "& a:focus-visible": {
    outline: "3px solid #00D9FF",
    outlineOffset: 2,
  },
  "& img": { display: "block", width: 32, height: 32 },
  [theme.breakpoints.up("md")]: {
    position: "fixed",
    left: "20.833vw",
    bottom: 24,
    transform: "translateX(-50%)",
    gap: 6,
    marginTop: 0,
    padding: theme.spacing(0.75),
    "& a": { width: 44, height: 44 },
    "& img": { width: 34, height: 34 },
  },
  [theme.breakpoints.up("lg")]: {
    left: "16.666vw",
  },
}));

const channels = [
  { label: "Facebook", href: "https://www.facebook.com/CFEFOCUS", icon: "./icons/facebook-icon.png" },
  { label: "TikTok", href: "https://www.tiktok.com/@cfe.focus?_t=ZM-8uobxBsAbhN&_r=1", icon: "./icons/tiktok-icon.svg" },
  { label: "LinkedIn", href: "https://linkedin.com/company/cfefocus", icon: "./icons/linkedin-icon.png" },
  { label: "Instagram", href: "https://www.instagram.com/cfefocus/", icon: "./icons/instagram-icon.png" },
  { label: "WhatsApp", href: "https://whatsapp.com/channel/0029VaDySzwFHWq0sH7IvR12", icon: "./icons/whatsapp-icon.png" },
  { label: "YouTube", href: "https://www.youtube.com/@CFEFOCUS", icon: "./icons/youtube-icon.png" },
];

export const SocialSection = ({ className }: { className?: string }) => (
  <SocialBox className={className} component="nav" aria-label="Redes sociales de Focus">
    {channels.map((channel) => (
      <a
        key={channel.label}
        target="_blank"
        rel="noreferrer"
        href={channel.href}
        aria-label={`${channel.label} de Focus (abre en una pestaña nueva)`}
      >
        <img alt="" src={channel.icon} />
      </a>
    ))}
  </SocialBox>
);
